import { Option } from '../types';

export type DjangoFontWidth =
    | null
    | 100
    | 140
    | 200
    | 295
    | 300
    | 400
    | 440
    | 450
    | 500
    | 550
    | 560
    | 600
    | 610
    | 650
    | 700
    | 800
    | 850
    | 900;

export const FONT_WIDTHS = [
    100,
    140,
    200,
    295,
    300,
    400,
    440,
    450,
    500,
    550,
    560,
    600,
    610,
    650,
    700,
    800,
    850,
    900,
    'variable',
] as const;

export type FontWidth = (typeof FONT_WIDTHS)[number];

export function isFontWidth(value: unknown): value is FontWidth {
    return FONT_WIDTHS.includes(value as FontWidth);
}

export const FONT_WIDTH_OPTIONS: Option<FontWidth>[] = [
    { value: 'variable', label: 'Variable' },
    { value: 100, label: 'Skyline' },
    { value: 140, label: 'Extra Compressed' },
    { value: 200, label: 'Compressed' },
    { value: 295, label: 'Compact' },
    { value: 300, label: 'Extra Condensed' },
    { value: 400, label: 'Condensed' },
    { value: 440, label: 'Narrow' },
    { value: 450, label: 'Semi Condensed' },
    { value: 500, label: 'Normal' },
    { value: 550, label: 'Big' },
    { value: 560, label: 'Semi Wide' },
    { value: 600, label: 'Wide' },
    { value: 610, label: 'Semi Extended' },
    { value: 650, label: 'Extra Wide' },
    { value: 700, label: 'Extended' },
    { value: 800, label: 'Extra Extended' },
    { value: 850, label: 'Ultra Wide' },
    { value: 900, label: 'Ultra Extended' },
] as const;
